import type { EditorSDK } from '@wix/platform-editor-sdk';

import { log } from '../../../../utils/monitoring';
import { APP_TOKEN } from '../../../constants';
import { getGlobalControllerRef } from '../../../wrappers/controllers';

export const removeGlobalControllerIfExists = async (editorSDK: EditorSDK) => {
  try {
    const controllerRef = await getGlobalControllerRef(editorSDK);

    if (controllerRef) {
      log('[SplitMA] removing global controller');
      await editorSDK.components.remove(APP_TOKEN, { componentRef: controllerRef });
    }
  } catch (e) {
    log('[SplitMA] Error occurred in removeGlobalControllerIfExists', { extra: { error: JSON.stringify(e) } });
  }
};
